import type { EventId } from '@ps/web-sports-api-types';

import type { ModelConfig, RootState, SelectorCreator, Slicer } from '@swf/core/store';
import type { ScoreboardData } from '@swf/sports/types/scoreboards';

import * as reducers from './reducers/scoreboards';
import type { ScoreboardsState } from './types/scoreboards';

export const initialState: ScoreboardsState = {
  scoreboards: {},
  hasNetworkError: false
};

const selectors = (slice: Slicer<ScoreboardsState>, createSelector: SelectorCreator) => ({
  eventScoreboard() {
    return createSelector(
      slice,
      (rootState: RootState, eventId: EventId) => eventId,
      (state, eventId): ScoreboardData | undefined => state.scoreboards[eventId]
    );
  },
  hasNetworkError() {
    return slice(({ hasNetworkError }) => hasNetworkError);
  }
});

interface ScoreboardsModel extends ModelConfig<ScoreboardsState> {
  selectors: typeof selectors;
  reducers: typeof reducers;
}

const scoreboards: ScoreboardsModel = {
  state: { ...initialState },
  selectors,
  reducers
};

export default scoreboards;
